/* Aeloo reels carousel.
   Arrows scroll the snap track by one card, and the buttons disable at the
   ends. Playback is driven by an IntersectionObserver so only the visible
   clips decode; `hover` mode swaps that for pointer enter/leave where a real
   pointer exists, and falls back to the observer on touch. */
(function () {
  function init(root) {
    if (!root || root.dataset.reelsReady === '1') return;
    root.dataset.reelsReady = '1';

    var track = root.querySelector('.aeloo-reels__track');
    var prev = root.querySelector('.aeloo-reels__arrow--prev');
    var next = root.querySelector('.aeloo-reels__arrow--next');
    if (!track || !prev || !next) return;

    function step() {
      var item = track.querySelector('.aeloo-reels__item');
      if (!item) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function sync() {
      var fits = track.scrollWidth <= track.clientWidth + 2;
      root.classList.toggle('aeloo-reels--fits', fits);
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
    sync();

    var conf = (window.aelooReels || {})[root.getAttribute('data-reels')] || {};
    var mode = conf.play || 'auto';
    if (mode === 'none') return;

    var canHover = window.matchMedia('(hover: hover)').matches;
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) {
              if (v.preload === 'none') v.preload = 'auto';
              var p = v.play();
              if (p) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
    }

    root.querySelectorAll('.aeloo-reels__video').forEach(function (v) {
      if (mode === 'hover' && canHover) {
        var card = v.parentNode;
        card.addEventListener('mouseenter', function () {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p) p.catch(function () {});
        });
        card.addEventListener('mouseleave', function () {
          v.pause();
          v.currentTime = 0;
        });
      } else if (io) {
        io.observe(v);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-reels]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
